// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__31M-H","content":"LoadingAlert_content__ckRud"};